// Vite env vars exposed to the browser. Service-role key is never exposed —
// only the anon key and the public URL, both safe to ship in the bundle per
// Supabase's documented client-side usage.

interface PublicEnv {
  readonly supabaseUrl: string;
  readonly supabaseAnonKey: string;
}

function readRequired(name: string, value: string | undefined): string {
  if (!value || value.length === 0) {
    throw new Error(
      `Missing required Vite env var ${name}. Set it in apps/web/.env.local for dev, ` +
        `or in the Cloudflare Pages env config for deployments.`,
    );
  }
  return value;
}

export const env: PublicEnv = {
  supabaseUrl: readRequired('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: readRequired('VITE_SUPABASE_ANON_KEY', import.meta.env.VITE_SUPABASE_ANON_KEY),
};
